import React from 'react';
import { useNavigate } from 'react-router-dom';
import './RegistrationPrompt.scss';

interface RegistrationPromptProps {
  isOpen: boolean;
  onClose: () => void;
}

export const RegistrationPrompt: React.FC<RegistrationPromptProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleRegister = () => {
    onClose();
    navigate('/register');
  };

  return (
    <div className="registration-prompt-overlay">
      <div className="registration-prompt-content">
        <h2>Great work on completing your first case!</h2>
        <p>To continue practicing more cases and get detailed feedback on your performance, please create an account.</p>
        <p>Benefits of registering:</p>
        <ul>
          <li>Access to all medical specialties and cases</li>
          <li>Detailed performance feedback and analytics</li>
          <li>Track your progress over time</li>
          <li>Save your favorite cases</li>
        </ul>
        <div className="registration-prompt-actions">
          <button className="primary-button" onClick={handleRegister}>
            Register Now
          </button>
          <button className="secondary-button" onClick={onClose}>
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
}; 